import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import CopyableValue from '../common/CopyableValue';

interface CopyableCardNumberProps {
  cardBin?: string | null;
  cardLast4?: string | null;
  revealOnHover?: boolean;
  textSx?: SxProps<Theme>;
}

// BIN and last 4 get their own copy targets because they get searched for separately.
export default function CopyableCardNumber({
  cardBin,
  cardLast4,
  revealOnHover = false,
  textSx,
}: CopyableCardNumberProps) {
  if (!cardBin && !cardLast4) return <>--</>;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {cardBin && (
        <CopyableValue
          text={cardBin}
          copyTitle="Copy BIN"
          revealOnHover={revealOnHover}
          // Hover button floats outside the text, so keep it clear of the last 4 next to it.
          copyButtonAlign={revealOnHover ? 'left' : 'right'}
          textSx={textSx}
        />
      )}
      {cardLast4 && (
        <CopyableValue
          text={`****${cardLast4}`}
          copyValue={cardLast4}
          copyTitle="Copy last 4"
          revealOnHover={revealOnHover}
          textSx={textSx}
        />
      )}
    </Box>
  );
}
